module.exports = "//static.hsappstatic.net/academy-common-lib/static-1.7891/images/certificate-blob.svg"